import React, { FC, useCallback, useState, useEffect } from 'react'
import moment from 'moment'
import TableComponent from '../../Elements/Table'
import StatusBadge from '../../Elements/StatusBadge'
import PrefixService from '../../../services/prefix'
import { useAPIRequest } from '../../../hooks/useAPIRequest'
import NumberWithCommas from '../../../utils/NumberWithCommas'
import { getTypeName } from '../../../utils/transactionType'
import { Member } from '../../../@types/member'
import FormattedMessage from '../../Elements/FormattedMessage'
// import { EyeOutlined } from '@ant-design/icons';


interface OtherTabProps {
    member: Member
    dateRange: any
}

const OtherTab: FC<OtherTabProps> = ({ member, dateRange }) => {
    const [dataSource, setDataSource] = useState<any>([])
    const { data, loading, update } = useAPIRequest(
        useCallback(
            async () =>
                PrefixService.getMemberTransactionList({
                    id: member.id,
                    dateRange: dateRange,
                    type: 'other',
                }),
            [member.id, dateRange]
        )
    )

    const columns = [
        {
            title: <FormattedMessage id="date_time" defaultMessage="วันที่/เวลา" />,
            dataIndex: 'createdAt',
            width: '160px',
            render: (text: any, record: any) => (
                <div className="row-datetime">
                    <div><span>{moment(record.createdAt).format('DD/MM/YYYY HH:mm:ss')}</span></div>
                    <div><FormattedMessage id="balance_update" defaultMessage="อัพเดทยอด" /> : {moment(record.updatedAt).format('DD/MM/YYYY HH:mm:ss')}</div>
                </div>
            )
        },
        {
            title: <FormattedMessage id="transfer_to" defaultMessage="โอนไปยัง" />,
            dataIndex: 'type',
            render: (text: any, record: any) => (
                <div>{getTypeName(record.type)}</div>
            )
        },
        {
            title: <FormattedMessage id="amount" defaultMessage="จำนวนเงิน" />,
            dataIndex: 'amount',
            render: (text: any, record: any) => (
                <>
                    <div className="row-amount">
                        <span>฿</span> {NumberWithCommas(record.amount, 2)}
                    </div>
                    {record.remark && <div className="row-remark mt-2">{record.remark}</div>}
                    {record.operator && <div className="row-operator bo-badge badge-light mt-2 text-danger" style={{ display: "in" }}><FormattedMessage id="listed_by" defaultMessage="ทำรายการโดย" /> : {record.operator}</div>}
                    <div className="bo-badge badge-light mt-2"><FormattedMessage id="turn2" defaultMessage="เทิร์น" /> {NumberWithCommas(record.turn)} <FormattedMessage id="times-turn-amount" defaultMessage="เท่า - ยอดเทิร์น" /> {NumberWithCommas(record.totalTurn, 2)}</div>
                </>
            )
        },
        {
            title: <FormattedMessage id="status" defaultMessage="สถานะ" />,
            dataIndex: 'status',
            width: '180px',
            render: (text: any, record: any) => (
                <StatusBadge status={record.status} />
            )
        }
    ]

    useEffect(() => {
        setDataSource(data)
    }, [data, loading, setDataSource])

    useEffect(() => {
        update()
    }, [dateRange])// eslint-disable-line

    return (
        <>
            <h5 className="mt-2 mb-3"><FormattedMessage id="transaction-other" defaultMessage="รายการอื่นๆ" /> <small className="sub-title">{`${NumberWithCommas(dataSource ? dataSource.length : 0)}`} <FormattedMessage id="list" defaultMessage="รายการ" /></small></h5>
            <div className="box-white ant-box-table">
                <TableComponent
                    columns={columns}
                    dataSource={dataSource || []}
                    loading={loading}
                    customOffsetHeader={-24}
                />
            </div>
        </>
    )
}
export default OtherTab